import { createColumnHelper } from '@tanstack/react-table';

import { useNumberFormatter } from '@mint-lib/formatting-hooks';

import { TableHeaderCell } from '@myn/mui';

//FYI: we are receiving dynamic data from DS team and we don't know column name and types
// If something changes in the future, we will do refactoring
type DynamicTableType = { [key: string]: string | number | boolean | null };

const columnHelper = createColumnHelper<DynamicTableType>();

export const getColumns = (data: {
  [key: string]: string | number | boolean | null;
}) => {
  const columnNames = Object.keys(data);

  return columnNames.map((el) =>
    columnHelper.accessor(el, {
      header: () => <TableHeaderCell>{formatTableLabel(el)}</TableHeaderCell>,
    }),
  );
};

export const formatTableLabel = (str: string) => {
  const spaced = str.replaceAll(/([A-Z])/g, ' $1').trim();

  return spaced
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

export const dataTableValueFormatter = (
  value: unknown,
  numberFormatter: ReturnType<typeof useNumberFormatter>,
): string => {
  if (Number(value) === value) {
    const numericValue = numberFormatter.format(value, {
      options: { maxDecimals: 2 },
    })?.formatted;

    if (!numericValue) return '-';

    return numericValue;
  }

  if (typeof value === 'string') return value;

  return '-';
};
